// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../commerce/(Goods)/GoodsDisplayConfig";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { WireType, } from "../../../../runtime/wire/index";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        goodsId: "0",
        displayConfig: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.goodsId !== undefined)
        result.goodsId = tsValueToJsonValueFns.int64(value.goodsId);
    if (value.displayConfig !== undefined)
        result.displayConfig = encodeJson_1(value.displayConfig);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.goodsId !== undefined)
        result.goodsId = jsonValueToTsValueFns.int64(value.goodsId);
    if (value.displayConfig !== undefined)
        result.displayConfig = decodeJson_1(value.displayConfig);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.goodsId !== undefined) {
        const tsValue = value.goodsId;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.displayConfig !== undefined) {
        const tsValue = value.displayConfig;
        result.push([2, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.goodsId = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.displayConfig = value;
    }
    return result;
}
